const reportTypes = window.SIMPL.reportTypes;

export default function GetReportTypes(no,dataKey) {
    // jsonが読み込めていない場合orjsonに定義されていない場合
    if(reportTypes == null || reportTypes.length <= 0) return null;

    // noが未設定
    if(no === undefined || no === null|| no === "") return null;

    var typeData = reportTypes.find(x => x.no === no);

    // 一致するものがない場合
    if(typeData === undefined || typeData === null) return null;

    return typeData[dataKey];
}